import { ChangeEvent, useEffect, useState } from "react";

import { PASSWORD_TYPES } from "../SecondSelectContent/BluetoothPassword/EnteredPassword/types/enums";
import { PASSWORD_SOURCE } from "../SecondSelectContent/BluetoothPassword/types/enums";
import { SelectedTask } from "../types/types";

const useBluetoothPassword = (selectedTask: SelectedTask) => {
    const [passwordSource, setPasswordSource] =
        useState<PASSWORD_SOURCE | null>(null);

    const [password, setPassword] = useState({
        [PASSWORD_TYPES.First]: "",
        [PASSWORD_TYPES.Repeat]: ""
    });

    useEffect(() => {
        setPasswordSource(null);
    }, [selectedTask?.type]);

    const changePasswordSource = (source: PASSWORD_SOURCE) =>
        setPasswordSource(source);

    const changePassword = (e: ChangeEvent<HTMLInputElement>) =>
        setPassword({ ...password, [e.target.name]: e.target.value });

    return { passwordSource, password, changePasswordSource, changePassword };
};

export { useBluetoothPassword };
